import { useState } from 'react';
import { PALETTES } from '../settings';
import Button from '@CS/components/Button';
import type { IColorPanelProps } from '../types';
import Arrow from '@/assets/images/icons/arrow.svg?component';
import ColorPicker from '@/components/AvatarOptionsPanel/ColorPicker';
import { Item, PopupContainer, ItemsContainer } from './ColorPanel.styles';

export const ColorPanel = ({
  palettes = PALETTES,
  label = '',
  color = '',
  title = '',
  setColor,
  onBack,
  popup
}: IColorPanelProps) => {
  const [updatePicker, setUpdatePicker] = useState(false);

  const handleSetColor = (value: string, update = false) => {
    setColor(value);
    if (!update) return;

    setUpdatePicker(true);
    setTimeout(() => setUpdatePicker(false), 100);
  };

  return (
    <>
      {popup && (
        <PopupContainer>
          <Button onClick={onBack} variant="iconFill">
            <Arrow />
          </Button>

          <h4>{title || label + ' kleur'}</h4>
        </PopupContainer>
      )}

      <ItemsContainer>
        {palettes.map((item, i) => (
          <Item
            key={i}
            value={item}
            onClick={() => handleSetColor(item, true)}
            isActive={
              (!color && !i) || color?.toLowerCase() === item.toLowerCase()
            }
          />
        ))}
      </ItemsContainer>

      <ColorPicker
        setColor={handleSetColor}
        update={updatePicker}
        label={label}
        color={color}
        popup={popup}
      />
    </>
  );
};
